module.exports = __webpack_public_path__ + "static/img/stay-option-icon-extra-pillows.80bc69dc.svg";